import { markFormGroupTouched, removeDuplicate } from 'src/app/controls/functions/shared-functions';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { viewDocument } from 'src/app/controls/functions/functions';
import { getInvalidFieldsV2, jsonDeepParse, prepareFieldConfigFlagsNew, setDefaultValue } from 'src/app/functions/shared-functions';
import { TranslateService } from '@ngx-translate/core';
import { JobseekerRegistrationService } from '../../services/registration/jobseeker-registration.service';
import { Console } from 'console';

@Component({
  selector: 'app-work-experience',
  templateUrl: './work-experience.component.html',
  styleUrls: ['./work-experience.component.scss'],
  providers:[JobseekerRegistrationService]
})
export class WorkExperienceComponent implements OnInit {
  master_data: any = {};
  workExperienceForm: UntypedFormGroup = new UntypedFormGroup({
    companyName: new UntypedFormControl(null),
    designationId: new UntypedFormControl(null),
    designationTitle: new UntypedFormControl(null),
    startDate: new UntypedFormControl(null),
    endDate: new UntypedFormControl(null),
    statusType: new UntypedFormControl(null),
    ctcCurrencyId: new UntypedFormControl(null),
    ctcAmount: new UntypedFormControl(null),
    ctcscaleId: new UntypedFormControl(null),
    notes: new UntypedFormControl(null),
    attachments: new UntypedFormControl(null),
  })
  exp_list = []
  validUploaded: boolean = true;
  all_rights: any = {};
  field_config_access: any = {};
  id = 0;
  jobseeker = {
    selected_jobtitle: [],
    jobTitleList: [],
    jobTitleMasters: {
      take: 100,
      skip: 0,
      totalcount: 0
    },
  }
  selected_designation
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog_ref: MatDialogRef<WorkExperienceComponent>,
    private dialog: MatDialog,
    private notification: NotificationService,
    private translate: TranslateService,
    private resume_srv: JobseekerRegistrationService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      console.log(this.data)
      if (this.data.id) {
        this.id = this.data.id
      }
      console.log(this.master_data)
      this.master_data = this.data.master_data;
      this.exp_list = jsonDeepParse(this.data.list) || [];
      console.log(this.master_data)
      this.all_rights = this.data.all_rights;
      if (this.all_rights) {
        this.field_config_access = prepareFieldConfigFlagsNew(this.all_rights, this.workExperienceForm, null, 'RES-Workexp_')
      }
    }


  }
  close() {

    this.dialog_ref.close()
  }
  save() {
    if (this.validUploaded) {
      this.dialog_ref.close(this.exp_list)
    }
    else {
      this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
    }
  }

  addExperience() {
    if (this.workExperienceForm.valid && this.validUploaded) {
      if (this.exp_list && this.exp_list.length) {
        this.exp_list.push(this.workExperienceForm.value);
      }
      else {
        this.exp_list = [this.workExperienceForm.value];
      }
      this.workExperienceForm.reset();
      setDefaultValue(this.workExperienceForm, 'ctcCurrencyId', this.master_data.currencyList, 'currencyId')
      setDefaultValue(this.workExperienceForm, 'ctcscaleId', this.master_data.scaleDurationList, 'scaleDurationId')
    }
    else {
      if (!this.validUploaded) {
        this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
        return;
      }
      else {
        markFormGroupTouched(this.workExperienceForm)
        getInvalidFieldsV2(this.workExperienceForm, this.translate, this.notification, 'RESUME.', null, this.field_config_access, 'RES-nom_')
      }
    }

  }

  editExperience(index) {
    this.workExperienceForm.patchValue(this.exp_list[index]);
    this.exp_list.splice(index, 1);
  }
  deleteExperience(index) {
    this.dialog
      .open(ConfirmationComponent, {
        width: "480px",
        height: "auto",
        panelClass: "icr-dialog",
        data: {
          title: "CONFIRMATION.confirmation",
          message: "CONFIRMATION.are_you_sure_to_delete",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.exp_list.splice(index, 1);
        }
      });
  }
  uploadedStatus(ev) {
    this.validUploaded = ev
  }
  viewAttachments(list) {
    viewDocument(list, list[0], this.dialog)
  }
  jobTitleChanged(ev) {
    this.selected_designation = ev
  }
  loadJobtitleList(ev) { //load job title based on search keywords
    if (ev) {
      this.resume_srv.getRequirementList({
        'search': ev.search
      }).subscribe(res => {
        if (res && res['data']) {
          if (res['data'].list && res['data'].list.length) {
            if (this.jobseeker.selected_jobtitle && this.jobseeker.selected_jobtitle.length) {
              this.jobseeker.jobTitleList = [...res['data'].list, ...this.jobseeker.selected_jobtitle];
              this.jobseeker.jobTitleList = removeDuplicate(this.jobseeker.jobTitleList, 'id')
            }
            else {
              this.jobseeker.jobTitleList = res['data'].list;

            }
          }
          else {
            this.jobseeker.jobTitleList = [];
          }

        }
      })
    }

  }
  // loadJobtitleList(ev) {}
}
